import * as React from "react";
import "./styles.scss";
import { Typography } from "@mui/material";
import SpeedRoundedIcon from "@mui/icons-material/SpeedRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";

const reasons = [
  {
    icon: SpeedRoundedIcon,
    title: "Practical Delivery",
    copy: "We focus on the workflows, decisions, and users that determine whether software actually gets adopted.",
  },
  {
    icon: InsightsRoundedIcon,
    title: "Operational Visibility",
    copy: "Products are shaped around reporting, accountability, and clear data flow for managers and operators.",
  },
  {
    icon: SecurityRoundedIcon,
    title: "Reliable Foundations",
    copy: "We prioritize maintainable architecture, secure handling, and systems that can grow with the business.",
  },
];

export default function WhyChooseUs() {
  return (
    <main id="whyChooseUs">
      <section className="why-hero">
        <div className="inner-container">
          <Typography className="eyebrow" variant="overline">
            Why Choose BRV
          </Typography>
          <Typography className="page-title" variant="h1">
            We build software around the way your business really operates.
          </Typography>
          <Typography className="lead" variant="body1">
            BRV is best suited for teams that need practical technology
            products, cleaner workflows, and implementation support that stays
            close to the realities of the operation.
          </Typography>
        </div>
      </section>

      <section className="reason-section">
        <div className="inner-container reason-grid">
          {reasons.map((reason) => {
            const Icon = reason.icon;
            return (
              <article key={reason.title}>
                <Icon />
                <Typography variant="h2">{reason.title}</Typography>
                <Typography variant="body1">{reason.copy}</Typography>
              </article>
            );
          })}
        </div>
      </section>
    </main>
  );
}
